module.exports = {
  path: '/giftBag',
  name: 'giftBag',
  meta: { title: '赛事推荐位', icon: 'el-icon-upload' },
  component: () => import('../views/giftBag/giftBag.vue')
}
